import {
  asBoolean,
  asDate,
  asNumber,
  asString,
  isObject,
} from "./model-utils";
import { Author } from "./author";
import { Host } from "./host";

export class PollQuestion {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.systemRemove = asBoolean(json.systemRemove);
    this.archive = asBoolean(json.archive);
    this.selectType = asString(json.selectType);
    this.pollQuestionId = asString(json.pollQuestionId);
    this.question = asString(json.question);
    this.pollId = asString(json.pollId);
    this.pollType = asString(json.pollType);
    this.profileId = asString(json.profileId);
    this.profileType = asString(json.profileType);
    this.profileIdentifier = asString(json.profileIdentifier);
    this.host = Host.fromJson(json.host);
    this.country = asString(json.country);
    this.countryCode = asString(json.countryCode);
    this.pollName = asString(json.pollName);
    this.author = Author.fromJson(json.author);
    this.createdAt = asDate(json.createdAt);
    this.updatedAt = asDate(json.updatedAt);
    this.totalOptions = asNumber(json.totalOptions);
    this.answered = asBoolean(json.answered);
  }

  get isAnswered() {
    return this.answered === true;
  }

  static fromJson(json: any) {
    return isObject(json) ? new PollQuestion(json) : json;
  }
}
